<div class="kt-widget14">
	<div class="kt-widget14__header kt-margin-b-30">
		<h3 class="kt-widget14__title">{{title}}</h3>
		<span class="kt-widget14__desc">{{desc}}</span>
	</div>
	<div class="kt-widget14__chart" style="height:120px;">
		<canvas #chart></canvas>
	</div>
</div>
